import React, { Component } from "react";

export default class Contact extends Component {
    render() {
        return (
            <div className="contact-card mr-4 mb-4">
                <p className="text-light p-3">Contact</p>
            </div>
        )
    }
}